import type { AssessmentRule, Question } from '@app/src/types/resourceExplorer'
import { AnswerRuleType } from '@app/src/types/resourceExplorer'

export const normalize = (value: string | number | undefined): string =>
  String(value ?? '')
    .trim()
    .toLowerCase()

export const isScoringRule = (rule: AssessmentRule): boolean => rule.points > 0 && !rule.isNeutral

export const getRulesForQuestion = (rules: AssessmentRule[], questionId: number): AssessmentRule[] =>
  rules.filter(rule => rule.questionId === questionId)

export const getScoringOptionValues = (question: Question, rules: AssessmentRule[]): string[] => {
  const items = question.requestCollection?.items
  if (!items?.length) return []
  const scoringValues = new Set(
    getRulesForQuestion(rules, question.id)
      .filter(isScoringRule)
      .filter(r => r.ruleType === AnswerRuleType.SelectedValue)
      .map(r => normalize(r.value)),
  )
  return items.map(item => item.value).filter(value => scoringValues.has(normalize(value)))
}
